const Yield = () => import('./Yield.vue')

const List = () => import('./pages/List.vue')
const Create = () => import('./pages/Create.vue')
const Edit = () => import('./pages/Edit.vue')

const routes = {
  component: Yield,
  path: '/recebimentos',
  meta: {
    label: 'Recebimentos'
  },
  children: [
    {
      path: '',
      component: List,
      name: 'yieldsList',
      meta: {
        label: 'Gerenciar Recebimentos',
        requiredPermission: {resource: 'yield', value: 'view'}
      }
    },
    {
      path: 'cadastro',
      component: Create,
      name: 'yieldCreate',
      meta: {
        hidden: true,
        label: 'Cadastrar',
        requiredPermission: {resource: 'yield', value: 'manage'}
      }
    },
    {
      path: 'atualizar/:id',
      component: Edit,
      name: 'yieldEdit',
      meta: {
        hidden: true,
        label: 'Atualizar',
        requiredPermission: {resource: 'yield', value: 'manage'}
      }
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/pages/yield/routes.js